import * as Actions from '../actionsgazeta';

const initialState = {};

const coluna = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_COLUNA_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_COLUNA_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default coluna;
